<div class="card" *ngIf="show_chart" mat-dialog-content style="border: none; margin: 0px;">
  <mat-card style="padding: 8px 0px 0px 0px;">
    <highcharts-chart id="container" [Highcharts]="Highcharts" (click)="onChartClick($event)"
      [constructorType]="chartConstructor" [options]="chart_options" [callbackFunction]="chartCallback"
      [(update)]="updateFromInput" [oneToOne]="true" style="width: 100%; height: 500px; display: block;">
    </highcharts-chart>
  </mat-card>
</div>